export const GET_ACCOUNT = 'GIFTYA/GET_ACCOUNT';
export const GET_ACCOUNT_RESET = 'GIFTYA/GET_ACCOUNT_RESET';
export const UPDATE_ACCOUNT = 'GIFTYA/UPDATE_ACCOUNT';
export const UPDATE_ACCOUNT_RESET = 'GIFTYA/UPDATE_ACCOUNT_RESET';
export const UPDATE_PROFILE_IMAGE = 'GIFTYA/UPDATE_PROFILE_IMAGE';
export const UPDATE_PROFILE_IMAGE_RESET = 'GIFTYA/UPDATE_PROFILE_IMAGE_RESET';
export const UPDATE_DETAILED_PROFILE_FORM_VIEWED = 'GIFTYA/UPDATE_DETAILED_PROFILE_FORM_VIEWED';
export const UPDATE_DETAILED_PROFILE_FORM_VIEWED_SUCCESS = 'GIFTYA/UPDATE_DETAILED_PROFILE_FORM_VIEWED_SUCCESS';
export const UPDATE_DETAILED_PROFILE_FORM_VIEWED_FAILURE = 'GIFTYA/UPDATE_DETAILED_PROFILE_FORM_VIEWED_FAILURE';
export const GET_REDEMPTION_ACCOUNTS = 'GIFTYA/GET_REDEMPTION_ACCOUNTS';
export const GET_REDEMPTION_ACCOUNTS_RESET = 'GIFTYA/GET_REDEMPTION_ACCOUNTS_RESET';
export const GET_REDEMPTION_ACCOUNT_TOKEN = 'GIFTYA/GET_REDEMPTION_ACCOUNT_TOKEN';
export const GET_REDEMPTION_ACCOUNT_TOKEN_RESET = 'GIFTYA/GET_REDEMPTION_ACCOUNT_TOKEN_RESET';


export const getAccount = (payload, meta, error) => ({
    type: GET_ACCOUNT,
    payload,
    meta,
    error
});
export const getAccountReset = (payload, meta, error) => ({
    type: GET_ACCOUNT_RESET,
    payload,
    meta,
    error
});

export const updateAccount = (payload, meta, error) => ({
    type: UPDATE_ACCOUNT,
    payload,
    meta,
    error
});
export const updateAccountReset = (payload, meta, error) => ({
    type: UPDATE_ACCOUNT_RESET,
    payload,
    meta,
    error
});

export const updateProfileImage = (payload, meta, error) => ({
    type: UPDATE_PROFILE_IMAGE,
    payload,
    meta,
    error
});
export const updateProfileImageReset = (payload, meta, error) => ({
    type: UPDATE_PROFILE_IMAGE_RESET,
    payload,
    meta,
    error
});

export const updateDetailedProfileFormViewed = (accountId) => ({
    type: UPDATE_DETAILED_PROFILE_FORM_VIEWED,
    accountId
});
export const updateDetailedProfileFormViewedSuccess = () => ({
    type: UPDATE_DETAILED_PROFILE_FORM_VIEWED_SUCCESS
});
export const updateDetailedProfileFormViewedFailure = () => ({
    type: UPDATE_DETAILED_PROFILE_FORM_VIEWED_FAILURE
});

export const getRedemptionAccounts = (payload, meta, error) => ({
    type: GET_REDEMPTION_ACCOUNTS,
    payload,
    meta,
    error
});
export const getRedemptionAccountsReset = (payload, meta, error) => ({
    type: GET_REDEMPTION_ACCOUNTS_RESET,
    payload,
    meta,
    error
});

export const getRedemptionAccountToken = (payload, meta, error) => ({
    type: GET_REDEMPTION_ACCOUNT_TOKEN,
    payload,
    meta,
    error
});
export const getRedemptionAccountTokenReset = (payload, meta, error) => ({
    type: GET_REDEMPTION_ACCOUNT_TOKEN_RESET,
    payload,
    meta,
    error
});